/* ========== AREA CHARTS ==========
 * Subtypes:
 *  - Area (uses drawLineChart with fillArea=true from line.js)
 *  - Stacked Area (drawStackedAreaChart, isPercent=false)
 *  - 100% Stacked Area (drawStackedAreaChart, isPercent=true)
 *  - 3-D Area (drawLineChart with fillArea=true and is3D=true from line.js)
 * ================================== */

import {
  COLORS,
  drawAxes,
  drawLegend,
  drawXAxisLabels,
} from './utils';

export function drawStackedAreaChart(ctx, x, y, width, height, chartObj, isPercent) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;
  var numCategories = Math.max.apply(null, seriesArr.map(function (s) { return s.data.length; }));
  if (numCategories === 0) return;

  var totals = new Array(numCategories).fill(0);
  for (var c = 0; c < numCategories; c++) {
    seriesArr.forEach(function (s) { totals[c] += s.data[c] || 0; });
  }
  var maxTotal = isPercent ? 1 : Math.max.apply(null, totals.concat([1]));
  var minValue = 0;
  var range = maxTotal - minValue || 1;

  // Y axis
  ctx.strokeStyle = '#E0E0E0';
  ctx.lineWidth = 1;
  for (var i = 0; i <= 5; i++) {
    var gy = y + height - (i / 5) * height;
    ctx.beginPath();
    ctx.moveTo(x, gy);
    ctx.lineTo(x + width, gy);
    ctx.stroke();
    var val = minValue + (i / 5) * range;
    ctx.fillStyle = '#888';
    ctx.font = '9px Arial';
    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
    ctx.fillText(isPercent ? Math.round(val * 100) + '%' : (val % 1 === 0 ? val.toString() : val.toFixed(1)), x - 4, gy);
  }

  var pointSpacing = width / Math.max(1, numCategories - 1);
  var prevSums = new Array(numCategories).fill(0);

  seriesArr.forEach(function (series, sIdx) {
    var color = series.color || COLORS[sIdx % COLORS.length];
    var currentSums = prevSums.map(function (s, ci) {
      var v = series.data[ci] || 0;
      var displayVal = isPercent ? (v / (totals[ci] || 1)) : v;
      return s + displayVal;
    });

    ctx.fillStyle = color;
    ctx.globalAlpha = 0.75;
    ctx.beginPath();
    for (var ci = 0; ci < numCategories; ci++) {
      var px = x + ci * pointSpacing;
      var py = y + height - (currentSums[ci] / range) * height;
      if (ci === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    }
    for (var ci2 = numCategories - 1; ci2 >= 0; ci2--) {
      var px2 = x + ci2 * pointSpacing;
      var py2 = y + height - (prevSums[ci2] / range) * height;
      ctx.lineTo(px2, py2);
    }
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = 1;

    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    for (var ci3 = 0; ci3 < numCategories; ci3++) {
      var px3 = x + ci3 * pointSpacing;
      var py3 = y + height - (currentSums[ci3] / range) * height;
      if (ci3 === 0) ctx.moveTo(px3, py3);
      else ctx.lineTo(px3, py3);
    }
    ctx.stroke();

    prevSums = currentSums;
  });

  var cats = chartObj.categories || [];
  var band = drawXAxisLabels(ctx, x, y + height, cats, numCategories, pointSpacing, false, chartObj.catLevels);

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr, { labelBand: band });
}
